export default __webpack_public_path__ + "static/media/cyberjump.5c650e9d.png";